<template>
  <div class="subpage-dashboards subpage-dashboard--user-profile">
    <h1 class="my-account__title gds-space-stack-xl">User Settings</h1>

    <editor-profile-name />
    <editor-profile-email />
    <widget-profile-username />
    <editor-profile-password />
    <div>
      <button @click="showDelete = true" type="button" class="gds-button red gds-text-button">
        <span class="gds-button__text">Delete User Account</span>
      </button>
    </div>
    <modal-delete-user :visible="showDelete" @complete="DeleteComplete" />
  </div>
</template>

<script>
import EditorProfileName from "./EditorProfileName";
import EditorProfileEmail from "./EditorProfileEmail";
import WidgetProfileUsername from "./WidgetProfileUsername";
import EditorProfilePassword from "./EditorProfilePassword";
import ModalDeleteUser from './ModalDeleteUser';

export default {
  name: "SubpageSettings",
  components: {
    EditorProfileName,
    EditorProfileEmail,
    WidgetProfileUsername,
    EditorProfilePassword,
    ModalDeleteUser,
  },
  data() {
    return {
      showDelete: false,
    };
  },
  computed: {
  },
  async mounted() {
  },
  methods: {
    DeleteComplete() {
      this.showDelete = false;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>